import React, {useEffect, useState} from "react";
import {Tooltip} from "antd";

// First Used for IconBase, update for other components

const withTooltip = (WrappedComponent)=>{

    return props => {
        const {defaultTooltipTitle, title, children, ...rest} = props;
        const useTitle = title ? title : defaultTooltipTitle ? defaultTooltipTitle:'no tooltip or default tooltip property';
        return (
            <Tooltip title={useTitle} enterDelay={0}>
                <WrappedComponent {...rest}>{children}</WrappedComponent>
            </Tooltip>
        );
    }
}

export default withTooltip;